import React, { FC } from 'react';
import { Typography } from '@material-ui/core';
import IndicativeNumberStyles from './indicativeNumberStyles';
import clsx from 'clsx';

export interface IIndicativeNumberProps {
  displayNumber: string | JSX.Element;
  dataTest?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  topOffset?: number;
}

const IndicativeNumber: FC<IIndicativeNumberProps> = ({ displayNumber, dataTest, onClick, className, topOffset }) => {
  const styles = IndicativeNumberStyles({ topOffset });

  if (!displayNumber) {
    return null;
  }

  return (
    <Typography
      data-test={`text:indicative_number:${dataTest ?? displayNumber}`}
      color={'textSecondary'}
      component={'span'}
      classes={{ root: clsx([className, styles.indicativeNumber]) }}
      onClick={onClick}
    >
      {displayNumber}
    </Typography>
  );
};

export default IndicativeNumber;
